"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coinsToCurrency = coinsToCurrency;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
var _currencyFormatter = require("./currencyFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function coinsToCurrency(coins, denom, currency, fractions, ui, bitMap) {
  if (!denom || !currency) {
    var state = _Core["default"].getState();
    denom = state.bet.denomination;
    currency = state.balance.currency;
    if (denom == undefined || currency == undefined) return "0";
  }
  // console.log('coinsToCurrency', coins * denom, currency, fractions, ui, bitMap)
  return (0, _currencyFormatter.currencyFormatter)(coins * denom, currency, undefined, fractions, ui, bitMap);
}
//# sourceMappingURL=coinsToCurrency.js.map